import {
  DataProcessingConfigInput,
  PipelineTemplateCreateStepsConfigurationInner,
  DataStagingConfigInput,
} from 'src/api-new/bifrost';

type Draftable<T> = T & { draft?: boolean };

export type DraftableStepConfiguration = Draftable<PipelineTemplateCreateStepsConfigurationInner>;

export type DraftableDataProcessingConfiguration = Draftable<DataProcessingConfigInput>;
export const DRAFT_DATA_PROCESSING_STEP: DraftableDataProcessingConfiguration = {
  id: 'draft',
  draft: true,
  type: 'data_processing',
  args: [],
  image: 'api_master',
  function_link: '',
  job_size: 'Micro (2 GB)',
  job_timeout: 36000,
  can_be_stopped: true,
};

export type DraftableDataStagingConfiguration = Draftable<DataStagingConfigInput>;
export const DRAFT_DATA_STAGING_STEP: DraftableDataStagingConfiguration = {
  id: 'draft',
  type: 'data_staging',
  draft: true,
};
